export default function addDays(theDate: Date, days = 1) {
  const newDate = new Date();
  newDate.setHours(0, 0, 0);
  const changeDate = theDate || newDate;
  let transformedDate = new Date(changeDate.getTime() + days * 24 * 60 * 60 * 1000);
  transformedDate.setHours(0, 0, 0, 0);
  return transformedDate;
}
